import { config } from "../../env";

export function authHeader(url, token) {
  let access_token = token || localStorage.getItem("accessToken");
  
  if (access_token) {
    return {
      Authorization: "Bearer " + access_token,
      "Content-Type": "application/json",
      "x-tenant-origin":
        window.location.host === "localhost:3000"
          ? config.SOURCE
          : window.location.host,
    };
  } else {
    return {
      "Content-Type": "application/json",
      "x-tenant-origin":
        window.location.host === "localhost:3000"
          ? config.SOURCE
          : window.location.host,
    };
  }
}
